import api from "../../fetch/api";
import * as types from "../types";

const state = {
  occupations:  [],
  relations: [],
  sexes: [],
  cardTypes:  [],
  educations:  []
};

const getters = {
  occupations: state => state.occupations,
  relations: state => state.relations,
  sexes: state => state.sexes,
  cardTypes: state => state.cardTypes,
  educations: state => state.educations
};

const mutations = {
  [types.SET_BASIC_OCCUPATIONS](state, res) {
    state.occupations = res;
  },
  [types.SET_BASIC_RELATIONS](state, res) {
    state.relations = res;
  },
  [types.SET_BASIC_SEXES](state, res) {
    state.sexes = res;
  },
  [types.SET_BASIC_CARD_TYPES](state, res) {
    state.cardTypes = res;
  },
  [types.SET_BASIC_EDUCATIONS](state, res) {
    state.educations = res;
  }
};

const actions = {
  setBasicData({ commit }) {
    api.getBasicData().then(re => {
      let reData = re.data;
      let occupationlist = [],
        relationlist = [],
        sexlist = [],
        cardlist = [],
        educationlist = [];
      reData.occupationlist.forEach(el => {
        occupationlist.push({
          key: el.OCCUPATION_ID,
          value: el.NAME
        });
      });
      reData.relationlist.forEach(el => {
        relationlist.push({
          key: el.RELATIONSHIP_ID,
          value: el.NAME
        });
      });
      reData.sexlist.forEach(el => {
        sexlist.push({
          key: el.flag,
          value: el.gender
        });
      });
      reData.cardlist.forEach(el => {
        cardlist.push({
          key: el.flag,
          value: el.type
        });
      });
      reData.educationlist.forEach(el => {
        educationlist.push({
          key: el.flag,
          value: el.education
        });
      });

      commit(types.SET_BASIC_OCCUPATIONS, occupationlist);
      commit(types.SET_BASIC_RELATIONS, relationlist);
      commit(types.SET_BASIC_SEXES, sexlist);
      commit(types.SET_BASIC_CARD_TYPES, cardlist);
      commit(types.SET_BASIC_EDUCATIONS, educationlist);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/basic.js